import { render, staticRenderFns } from "./productSalesRecords.vue?vue&type=template&id=c831bada&scoped=true&"
import script from "./productSalesRecords.vue?vue&type=script&lang=js&"
export * from "./productSalesRecords.vue?vue&type=script&lang=js&"
import style0 from "./productSalesRecords.vue?vue&type=style&index=0&id=c831bada&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c831bada",
  null
  
)

export default component.exports